import { useState, useEffect } from 'react';

export const useDeviceDetection = () => {
  const [deviceType, setDeviceType] = useState('desktop');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const screenWidth = window.innerWidth;
      
      // Check for mobile devices - more restrictive approach
      const mobileRegex = /android.*mobile|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
      const tabletRegex = /ipad|android(?!.*mobile)|tablet/i;
      
      // Screen width thresholds
      const isSmallScreen = screenWidth <= 480;
      const isMediumScreen = screenWidth <= 768;
      const isLargeScreen = screenWidth <= 1024;
      
      // More specific device detection
      let detectedDevice = 'desktop';
      let isMobileDevice = false;
      
      if (/iphone|ipod/.test(userAgent) || (isSmallScreen && /safari/i.test(userAgent))) {
        detectedDevice = 'iphone';
        isMobileDevice = true;
      } else if (/ipad/.test(userAgent)) {
        detectedDevice = 'ipad';
        isMobileDevice = isMediumScreen; // iPad only mobile if screen is small
      } else if (/android.*mobile/.test(userAgent)) {
        detectedDevice = 'android-phone';
        isMobileDevice = true;
      } else if (/android/.test(userAgent)) {
        detectedDevice = 'android-tablet';
        isMobileDevice = isMediumScreen;
      } else if (mobileRegex.test(userAgent)) {
        detectedDevice = 'phone';
        isMobileDevice = true;
      } else if (tabletRegex.test(userAgent) && isMediumScreen) {
        detectedDevice = 'tablet';
        isMobileDevice = true;
      } else if (isSmallScreen) {
        detectedDevice = 'phone';
        isMobileDevice = true;
      } else if (isMediumScreen) {
        detectedDevice = 'tablet';
        isMobileDevice = true;
      }
      
      setDeviceType(detectedDevice);
      setIsMobile(isMobileDevice);
      
    };

    // Initial detection
    detectDevice();
    
    // Re-detect on window resize
    window.addEventListener('resize', detectDevice);
    
    return () => window.removeEventListener('resize', detectDevice);
  }, []);

  return { deviceType, isMobile };
};
